import getDeleteCookieString from './getDeleteCookieString';

export default function deleteCookie(params: { domain?: string; name: string }): void {
  const toDelete = getDeleteCookieString(params);

  if (toDelete) {
    document.cookie = toDelete;
  }
}
